/**
 * Whether the user may enter the authenticated app (login redirect + private routes).
 * Requires at least one capability flag or scoped event access from an invite (allowedEventIds).
 */
export function userHasMeaningfulAllowedEventIds(allowedEventIds: string | null | undefined): boolean {
    if (allowedEventIds == null || allowedEventIds === '') {
        return false;
    }
    if (allowedEventIds === 'all') {
        return true;
    }
    try {
        const ids = JSON.parse(allowedEventIds) as unknown;
        return Array.isArray(ids) && ids.length > 0;
    } catch {
        return false;
    }
}

type UserRowForAppAccess = {
    admin?: boolean;
    editMapStationsNotes?: boolean;
    createEditEventInfo?: boolean;
    viewWasteData?: boolean;
    editWasteData?: boolean;
    generateReports?: boolean;
    editTodos?: boolean;
    completeTodos?: boolean;
    viewInventory?: boolean;
    manageInventory?: boolean;
    editUsers?: boolean;
    allowedEventIds?: string | null;
};

export function userHasAppAccess(user: UserRowForAppAccess | null | undefined): boolean {
    if (!user) {
        return false;
    }
    const hasAnyPermission =
        user.admin ||
        user.editMapStationsNotes ||
        user.createEditEventInfo ||
        user.viewWasteData ||
        user.editWasteData ||
        user.generateReports ||
        user.editTodos ||
        user.completeTodos ||
        user.viewInventory ||
        user.manageInventory ||
        user.editUsers;
    if (hasAnyPermission) {
        return true;
    }
    return userHasMeaningfulAllowedEventIds(user.allowedEventIds);
}
